import { createRoot } from 'react-dom/client';
import { ConfigProvider } from "antd"; // ✅ Import ConfigProvider
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import 'assets/fonts/sicpa/sicpa.css';
import 'simplebar/src/simplebar.css';
import 'assets/third-party/apex-chart.css';
import 'assets/css/custom.css'
import App from './App';
import { store } from 'store';
import reportWebVitals from './reportWebVitals';
import { APP_BASE_NAME } from './config';
import clearLocalStorage from 'helper/localStorageClear';
// import 'antd/dist/antd.css'; // Ensure this line is here

clearLocalStorage()
const container = document.getElementById('root');
const root = createRoot(container);
// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

root.render(
  <ReduxProvider store={store}>
    <BrowserRouter basename={APP_BASE_NAME}>
      <ConfigProvider>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </ReduxProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
